import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type UpdateSeamVisionlineUserRequest = {
  clientId: string
  entranceIds: string[]
  expirationDate?: string
}

const updateSeamVisionlineUser = async (data: UpdateSeamVisionlineUserRequest) => {
  const response = await authAPI.put(`/seam-visionline/users/${data.clientId}`, {
    entranceIds: data.entranceIds,
    expirationDate: data.expirationDate,
  })
  return response.data
}

export const useUpdateSeamVisionlineUser = () =>
  useMutation({
    mutationFn: updateSeamVisionlineUser,
  })
